import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import NotesSearch from './NotesSearch';
import { noteCategories } from '@/mocks/notes';

export default function NotesHero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative pt-32 pb-16 md:pt-44 md:pb-20 overflow-hidden bg-[#faf8f5]">
      {/* Subtle background texture */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[40vw] h-full opacity-20">
          <img
            src="https://readdy.ai/api/search-image?query=elegant%20guzheng%20instrument%20close%20up%20detail%20silk%20strings%20wooden%20frame%20subtle%20texture%20background%2C%20soft%20warm%20natural%20lighting%2C%20minimal%20zen%20aesthetic%2C%20cream%20and%20wheat%20tones%2C%20artistic%20still%20life%20photography&width=900&height=800&seq=noteshero001&orientation=portrait"
            alt=""
            className="w-full h-full object-cover object-left"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#faf8f5] via-[#faf8f5]/70 to-transparent"></div>
        </div>
      </div>

      <div
        className={`relative z-10 w-full px-6 md:px-12 lg:px-20 transition-all duration-1000 ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
        }`}
      >
        {/* Label */}
        <div className="flex items-center gap-3 mb-7">
          <div className="w-6 h-px bg-[#b08060]"></div>
          <span className="text-[0.8125rem] tracking-[0.2em] text-[#b08060] font-medium uppercase">
            Mingzheng Notes
          </span>
        </div>

        <div className="flex flex-col lg:flex-row lg:items-end gap-10 lg:gap-20">
          {/* Left: Title + Description */}
          <div className="lg:w-[40%] shrink-0">
            <h1
              className="font-serif-tc text-[#2c2420] leading-[1.3] mb-5"
              style={{ fontSize: 'clamp(2rem, 4.5vw, 3rem)' }}
            >
              鳴箏筆記
            </h1>
            <p className="text-[1.0625rem] leading-[1.8] text-[#5a4a3a]/80 mb-7">
              關於古箏學習、選箏指南與教學日常的文字。
              <br className="hidden md:block" />
              寫給每一個對音樂有好奇、也有猶豫的人。
            </p>
            {/* Category Quick Links */}
            <div className="flex flex-wrap gap-2">
              {noteCategories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/notes?category=${cat.id}`}
                  className="px-3.5 py-1.5 rounded-full border border-[#d4c4b0] text-[0.875rem] text-[#7a6248] hover:bg-[#7a6248] hover:text-white hover:border-[#7a6248] transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  {cat.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Right: Search */}
          <div className="flex-1">
            <div className="mb-3">
              <p className="text-[0.8125rem] tracking-[0.12em] text-[#b08060] font-medium uppercase mb-1">
                快速搜尋
              </p>
              <p className="text-[0.875rem] text-[#9a8878]">輸入你感興趣的主題、關鍵字或問題</p>
            </div>
            <NotesSearch />
          </div>
        </div>
      </div>
    </section>
  );
}
